var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_2101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.3677 18.633 0 12 0ZM12 22.3256C6.30647 22.3256 1.67442 17.6936 1.67442 12C1.67442 6.30642 6.30647 1.67442 12 1.67442C17.6935 1.67442 22.3256 6.30642 22.3256 12C22.3256 17.6936 17.6935 22.3256 12 22.3256Z",
    fill: "#E11B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 10.0029C11.2896 10.0029 10.7842 10.3031 10.7842 10.7454V16.7635C10.7842 17.1426 11.2896 17.5216 12.0004 17.5216C12.6797 17.5216 13.2325 17.1426 13.2325 16.7635V10.7453C13.2325 10.3031 12.6797 10.0029 12.0004 10.0029Z",
    fill: "#E11B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 6.29102C11.2737 6.29102 10.7051 6.81227 10.7051 7.4125C10.7051 8.01278 11.2737 8.54983 12.0003 8.54983C12.7111 8.54983 13.2798 8.01278 13.2798 7.4125C13.2798 6.81227 12.711 6.29102 12.0003 6.29102Z",
    fill: "#E11B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_2101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fb62e0f086764364d5763dc320f65854.svg";
export { ForwardRef as ReactComponent };